
import {
    defineComponent,
    getCurrentInstance,
    onActivated,
    reactive,
    toRefs,
    Ref,
    ref,
    computed,
    onMounted,
    onUnmounted,
    watch,
    nextTick,
    PropType,
    onDeactivated,
} from 'vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import Toast from 'vant/lib/toast';
import debounce from 'lodash/debounce';
// import { internal, toNano, Address } from '@ton/core';
import { useWatchVideoLog } from '../../hooks/useWatchVideoLog';
import { isTMA, initTg, useTelegram, tgNetworkHelper, tonConnectUI } from '../../hooks/useTelegram';
// import Loading from '../loading/index.vue';
import VideoTagWarp from './components/video-tag-warp.vue';
import VideoAction from './components/video-action.vue';
import VideoInfo from './components/video-info.vue';
// import VideoBottomCollection from '@/components/video-bottom-collection/index.vue'
import AddToHomeScreenOld from '@/components/add-to-home-screen/index.vue';
import LoginPopup from '@/components/login/index.vue';
import { immediateSendLog, sendLog, LogType, radarLog } from '@/common/radar';
import HeaderTabs from '@/components/header-tabs/index.vue';
import { getVideoClipType, formatUrls, isPwa, getQuery } from '@/common/utils';
import { isLogin } from '@/common/login';
import CommentDialog from '@/components/comment-dialog/seo-index.vue';
import { useCommentDialog } from '@/components/comment-dialog/hooks/useCommentDialog';
import 'swiper/css/swiper.css';
import PraiseViaTelWallet from '@/components/praise-via-tel-wallet/index.vue';
import PraisePendant from '@/components/praise-via-tel-wallet/pendant.vue';
import { PWAFromPage } from '@/api/base';

enum PopType {
    function_interaction_guidance = 'function_interaction_guidance', // 功能交互类引导 ?
    more_than_7s = 'more_than_7s', // 播放>7s弹窗
    swipe_down_block = 'swipe_down_block', // 下滑阻断弹窗
    install_guidance = 'install_guidance', // 安装引导弹窗（关闭功能类交互引导弹窗后触发）
    cold_launch = 'cold_launch', // 冷启弹窗
    video_interaction_guidance = 'video_interaction_guidance', // 视频交互类引导 ?
}
enum VideoGuidanceSource {
    share = 'share', // 转发
    under_button = 'under_button', // 下方button
    profile = 'profile', // 进入p页
    comment = 'comment', // 评论
    follow = 'follow', // 转发
    favorite = 'favorite', // 点赞
    together = 'together', // 合拍
    tag = 'tag',
    name = 'name',
    photo = 'photo',
}

export default defineComponent({
    components: {
        Swiper,
        SwiperSlide,
        VideoAction,
        VideoInfo,
        VideoTagWarp,
        // AddToHomeScreenNew,
        AddToHomeScreenOld,
        CommentDialog,
        // OpenKwaiNotice,
        HeaderTabs,
        LoginPopup,
        // VideoBottomCollection,
        PraiseViaTelWallet,
        PraisePendant,
    },
    props: {
        videoList: {
            type: Array as PropType<Array<any>>,
            default: () => [],
        },
        isIos: {
            type: Boolean,
            default: false,
        },
        showTab: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['load-more', 'refresh', 'change'],
    setup(props, ctx) {
        let isFirstDone = false;
        const { commentLists, commentDialogVisable, showCommentLoading, fetchSeoComment } = useCommentDialog();
        const { createTgWalletOrder, tgWebAppStartup, tgPraiseAmountList, tonapiExchangeUSDToTon } = tgNetworkHelper();
        const istma = ref(false);
        const showPlayBtn = ref(true); // 暂停键
        const showPoster = ref(true); // poster 展示
        const slideIndex = ref(0); // 当前swiper滚动至
        const preSlideIndex = ref(0); // 滑动至当前slide index 上一个的位置
        const isTouchMove = ref(false);
        const { proxy } = getCurrentInstance() as { proxy: any };
        const startupData: any = proxy.$store.state.startup;
        const showAddToScreenNew = ref(false); // 新的添加到桌面全屏弹窗
        const showAddToScreenOld = ref(false); // 旧的添加到桌面底部弹窗
        const alreadyShowAbBlockDialog = ref(false); // 是否展示过ab阻断弹窗
        const slideTimes = ref(0); // 记录左滑次数
        const formatVideoList = ref([]) as Ref<Array<any>>;
        const videoClickCount = ref(0); // 单击双击
        const videoRefs = ref([]);
        const swiperRef = ref();
        const iosVideoCompRef = ref(null);

        const showNewOpenKwaiNotice = ref(true); // 新版本底部打开kwai弹窗
        const showWakeNotice = ref(false); // 老的点击拉起kwai弹窗

        const showPayViaWalletNotice = ref(false); // 拉起telegram wallet打赏
        const showTelegramWidget = ref(false); // 小程序挂件

        const showLoginPopup = ref(false); // 是否展示登陆

        const watchOneVideoTime = ref(0); // 记录一个视频看了多长时间
        const loading = ref(false);

        const isAllowLoginPopupClose = ref(true); // 是否允许登录面板关闭

        const commentRef = ref(null);
        const query = getQuery();
        let tonConnector: any;
        // ab参数
        const PWA_share_N_string = Number(query.PWA_share_N_string || 10);

        // 当前展示的视频信息
        const activePhotoItem = computed(() => {
            return props.videoList[slideIndex.value];
        });

        const kwaiId = computed(() => {
            return activePhotoItem.value.kwai_id || activePhotoItem.value.user.kwai_id;
        });

        const preActivePhotoItem = computed(() => {
            return props.videoList[preSlideIndex.value];
        });

        const activePhotoItemLiked = computed(() => {
            return !!formatVideoList.value[slideIndex.value].liked;
        });

        // 视频id
        const photo_id = computed(() => {
            return activePhotoItem.value?.photo_id_str;
        });
        const pre_photo_id = computed(() => {
            return preActivePhotoItem.value?.photo_id_str;
        });
        // 作者id
        const author_id = computed(() => {
            return activePhotoItem.value?.user_id;
        });

        // 计算观看时间hooks
        const { activeVideoPlayingTime, sendVideoTimeLog, startPlayTime, sendPlayToPlayingTimeLog } = useWatchVideoLog({
            slideIndex,
            pre_photo_id,
            photo_id,
            author_id,
        });

        // 弹窗埋点
        const pop_type = ref(PopType.cold_launch);
        const moreThan7sPropsBeforePopType = ref('');
        const video_guidance_source = ref(''); // 引导弹窗是哪里唤起的
        const sendPopShowLog = (logParams: { logType: keyof typeof LogType; logParams?: Record<string, string> }) => {
            const { logType } = logParams;

            const params: any = {
                author_id: author_id.value,
                photo_id: photo_id.value,
                pop_type: pop_type.value,
                ...logParams,
            };
            if (pop_type.value === PopType.video_interaction_guidance) {
                params.video_guidance_source = video_guidance_source.value;
            }

            sendLog({
                type: logType,
                name: 'PWA_POP',
                value: {
                    ...params,
                },
            });
        };

        // 小程序弹窗埋点
        const sendTelegramPraisePopLog = (logParams: { logType: 'click' | 'show'; logParams?: Record<string, string> }) => {
            const { logType } = logParams;
            const params: any = {
                author_id: author_id.value,
                photo_id: photo_id.value,
                pop_type: pop_type.value,
                is_telegram: istma,
                ...logParams,
            };
            if (pop_type.value === PopType.video_interaction_guidance) {
                params.video_guidance_source = video_guidance_source.value;
            }

            sendLog({
                type: logType,
                name: 'REWARD_POP',
                value: {
                    ...params,
                },
            });
        };

        // 小程序挂件埋点
        const sendTelegramWidgetLog = (logParams: { logType: 'click' | 'show'; logParams?: Record<string, string> }) => {
            const { logType } = logParams;
            const params: any = {
                author_id: author_id.value,
                photo_id: photo_id.value,
                pop_type: pop_type.value,
                is_telegram: istma,
                ...logParams,
            };
            if (pop_type.value === PopType.video_interaction_guidance) {
                params.video_guidance_source = video_guidance_source.value;
            }

            sendLog({
                type: logType,
                name: 'TELEGRAM_WIGET',
                value: {
                    ...params,
                },
            });
        };
        // 监控弹窗 发送弹窗埋点
        watch(
            () => [
                showWakeNotice.value,
                showAddToScreenNew.value,
                showAddToScreenOld.value,
                showNewOpenKwaiNotice.value,
                showPayViaWalletNotice.value,
                showTelegramWidget.value,
            ],
            ([
                showWakeNoticeVal,
                showAddToScreenNewVal,
                showAddToScreenOldVal,
                showNewOpenKwaiNoticeVal,
                showPayViaWalletNotice,
                showTelegramWidget,
            ]) => {
                if (showWakeNoticeVal || showAddToScreenNewVal || showAddToScreenOldVal || showNewOpenKwaiNoticeVal) {
                    nextTick(() => {
                        sendPopShowLog({ logType: 'show' });
                    });
                } else if (showPayViaWalletNotice) {
                    nextTick(() => {
                        sendTelegramPraisePopLog({ logType: 'show' });
                    });
                } else if (showTelegramWidget) {
                    nextTick(() => {
                        sendTelegramWidgetLog({ logType: 'show' });
                    });
                }
            }
        );

        const state: any = reactive({
            videoElement: null,
            timer: null,
            videoClickTimer: null, // 双击的时间函数
        });

        const getObjectFit = (extParams: any) => {
            const type = getVideoClipType(extParams?.w, extParams?.h);
            return type === 2 ? 'contain' : 'cover';
        };
        const getVideoPlayer = (index = slideIndex.value) => {
            const videoComp = videoRefs.value[index] as any;
            return videoComp;
        };
        // 获取当前播放的video元素
        const getVideoEle = (index?: string) => {
            if (props.isIos) {
                return document.querySelector('.ios-video');
            }
            const videoComp = videoRefs.value[slideIndex.value] as any;
            return videoComp;
        };

        const setVideoPause = () => {
            if (!state.videoElement) {
                state.videoElement = getVideoEle();
            }
            clearInterval(state.timer);
            state.videoElement?.pause();
            showPlayBtn.value = true;
            loading.value = false;
        };

        const setVideoPlay = () => {
            state.videoElement = getVideoEle();
            console.log('setVideoPlay', state.videoElement);
            const playPromise = state.videoElement?.play();
            showPlayBtn.value = false;
            startPlayTime.value = new Date().getTime();

            if (typeof playPromise !== 'undefined') {
                playPromise
                    .then(() => {
                        // 记录play 到playing 的时间
                        sendPlayToPlayingTimeLog({ index: slideIndex.value });
                        // 记录播放时间
                        proxy.$bus.emit('isLoad', false);

                        showPlayBtn.value = false;
                        showPoster.value = false;
                        loading.value = false;

                        // 单次播放的视频 时长
                        if (state.timer) {
                            clearInterval(state.timer);
                            state.timer = setInterval(() => {
                                watchOneVideoTime.value++;
                            }, 1000);
                        } else {
                            state.timer = setInterval(() => {
                                watchOneVideoTime.value++;
                            }, 1000);
                        }
                    })
                    .catch(() => {
                        showPoster.value = true;
                    });
            } else {
                showPoster.value = false;
                loading.value = false;
                proxy.$bus.emit('isLoad', false);
            }
        };

        // 屏幕双击
        const checkDbClick = async (e: MouseEvent) => {
            videoClickCount.value++;
            if (videoClickCount.value === 1) {
                state.videoClickTimer = setTimeout(() => {
                    videoClickCount.value = 0;
                    onClickVideo();
                }, 300); // 设置一个时间间隔，单位为毫秒
            } else if (videoClickCount.value === 2) {
                clearTimeout(state.videoClickTimer);
                videoClickCount.value = 0;
                // 双击埋点
                sendLog({
                    type: 'click',
                    name: 'DOUBLE_LIKE',
                });
                // 点击位置展示红心
                renderLiked(e);
                if (!activePhotoItemLiked.value) {
                    // clickLickAction()
                    debounceClickLikeAction();
                }
            }
        };
        // 在点击位置渲染红心
        const renderLiked = (event: MouseEvent) => {
            const heartWrap = document.createElement('div');
            const heartIcon = document.createElement('div');
            heartIcon.className = 'heart-icon';
            heartIcon.style.transform = `rotate(${Math.floor(Math.random() * 61) - 30}deg)`;
            heartWrap.className = 'heart-dbclick-warp';
            heartWrap.style.top = `${event.clientY}px`;
            heartWrap.style.left = `${event.clientX}px`;

            heartWrap.appendChild(heartIcon);
            document.body.appendChild(heartWrap);
            setTimeout(() => {
                document.body.removeChild(heartWrap);
            }, 300);
        };

        // 点赞
        const clickLickAction = async () => {
            const { isLogin } = proxy.$store.state || {};
            if (!isLogin) {
                showLoginPopup.value = true;
                return;
            }
            radarLog({
                name: 'PWA_FAVORITE_ISLOGIN',
                event_type: 'show',
                category: 'KWAI_SHARE',
                message: `PWA_FAVORITE_ISLOGIN`,
                src: window.location.pathname,
            });
            const { result, errorMsg } = await proxy.$axios.$$post('overseaAPI::/rest/o/w/pwa/likeAction', {
                fromPage: 'PWA_FOR_YOU',
                cancel: activePhotoItemLiked.value, //
                photoId: photo_id.value,
            });
            const likedValue = activePhotoItemLiked.value ? 0 : 1;

            if (result === 1) {
                const item = formatVideoList.value[slideIndex.value];
                item.liked = likedValue;
                // 点赞成功加1 点赞失败-1
                activePhotoItemLiked.value ? item.like_count++ : item.like_count--;
                // 未登录
            } else if (result === 109 || result === 1047232003) {
                showLoginPopup.value = true;
                onClickVideo();
            } else {
                errorMsg &&
                    Toast({
                        message: errorMsg,
                    });
            }
        };

        const debounceClickLikeAction = debounce(clickLickAction, 500, { leading: true, trailing: false });

        // 关注成功后将列表全部的相同作者设置为关注成功
        const setAllSameUserFollowed = (userId: number) => {
            formatVideoList.value.forEach((item: { following: number; user_id: number }) => {
                if (item.user_id === userId) {
                    item.following = 1;
                }
            });
        };
        // 关注
        const clickFollowAction = async () => {
            const { isLogin } = proxy.$store.state || {};
            if (!isLogin) {
                showLoginPopup.value = true;
                return;
            }

            radarLog({
                name: 'PWA_FOLLOW_ISLOGIN',
                event_type: 'show',
                category: 'KWAI_SHARE',
                message: `PWA_FOLLOW_ISLOGIN`,
                src: window.location.pathname,
            });
            const { result, errorMsg, data } = await proxy.$axios.$$post('overseaAPI::/rest/o/w/pwa/followAction', {
                toUid: author_id.value, //
                fType: 1,
                photoId: photo_id.value,
                noticeId: '',

                sourcePageTag: window.location.href.replace(/\?.*/, ''),
                contentType: 'photo',
                contentId: photo_id.value,
                fromPage: PWAFromPage.PWA_FOR_YOU,
            });

            if (result === 1) {
                // 关注已发送，对方设置了隐私保护
                if (data?.followStatus === 2) {
                    Toast({
                        message: proxy.$root.$t('k_327834'),
                    });
                }
                setAllSameUserFollowed(author_id.value);
            } else if (result === 109 || result === 1047232003) {
                showLoginPopup.value = true;
            } else {
                errorMsg &&
                    Toast({
                        message: errorMsg,
                    });
            }
        };

        const debounceClickFollowAction = debounce(clickFollowAction, 500, { leading: true, trailing: false });

        const onClickVideo = () => {
            if (!state.videoElement) {
                state.videoElement = getVideoEle();
            }
            const pausedFlag = props.isIos ? state.videoElement?.paused : state.videoElement?.getPaused();
            // const pausedFlag = state.videoElement?.getPaused()
            if (pausedFlag) {
                showPlayBtn.value = false;
                setVideoPlay();
            } else {
                clearInterval(state.timer);
                state.videoElement?.pause();
                showPlayBtn.value = true;
                loading.value = false;
            }
        };

        const onError = (e: any) => {
            console.log('onError', e);
        };

        watch(
            () => slideIndex.value,
            (newValue, oldValue) => {
                preSlideIndex.value = oldValue;
                // // todo ab传入的 N 7
                if (newValue + 1 > PWA_share_N_string && !alreadyShowAbBlockDialog.value) {
                    showNewOpenKwaiNotice.value = true;
                    alreadyShowAbBlockDialog.value = true;
                    pop_type.value = PopType.swipe_down_block;
                }
            }
        );

        let timer: any = null;

        const swiperOption = {
            direction: 'vertical',
            on: {
                touchMove: () => {
                    if (props.isIos) {
                        showPoster.value = true;
                        isTouchMove.value = true;
                    }
                },
                touchEnd() {
                    const swiper: any = this;
                    if (swiper.isEnd) {
                        ctx.emit('load-more');
                    }

                    //  左滑刷新 退出逻辑
                    const X = swiper.touches.startX - swiper.touches.currentX;
                    if (!swiper.swipeDirection && X > 0) {
                        // console.log('左滑了', X)
                        slideTimes.value += 1;
                        timer = setTimeout(() => {
                            if (slideTimes.value >= 2) {
                                slideTimes.value = 0;

                                !isPwa() && window.open('about:blank', '_self');
                                window.close();
                            } else {
                                proxy.$bus.emit('isLoad', true);
                                setVideoPause();
                                // 移动到第0个start
                                slideIndex.value = 0;
                                swiperRef.value.$swiper.slideTo(0, 0);
                                // 移动到第0个end
                                ctx.emit('refresh');
                                slideTimes.value = 0;
                            }
                            clearTimeout(timer);
                        }, 600);
                    }
                },
                slideChangeTransitionEnd() {
                    const swiper: any = this;
                    // 统计播放时长
                    // logVideoPlayTime();
                    // 先展示出来poster，等视频加载完成后再去掉
                    if (!state.videoElement) {
                        state.videoElement = getVideoEle();
                    }
                    showPoster.value = true;
                    state.videoElement?.pause();
                    // state.videoElement?.load();

                    // if (state.isInteracted) {
                    //   showPlayBtn.value = false;
                    // }
                    slideIndex.value = swiper.realIndex;
                    setTimeout(() => {
                        // 重制观看单个视频时间
                        watchOneVideoTime.value = 0;
                        setVideoPlay();
                        // todo
                        ctx.emit('change', props.videoList[swiper.realIndex]);
                    }, 100);

                    // if (swiper.isEnd) {
                    //  ctx.emit('load-more');
                    //  // 始终保持少于五个 就加载一次
                    // } else if (props.videoList.length - swiper.realIndex < 5) {
                    //  ctx.emit('load-more');
                    // }
                },
            },
        };

        const handleAddToScreenNew = () => {
            sendLog({
                type: 'click',
                name: 'PWA_POP',
                value: {
                    author_id: author_id.value,
                    photo_id: photo_id.value,
                    button_type: 'main',
                    skip_to: 'icon',
                    pop_type: PopType.more_than_7s,
                },
            });
            handleAddToScreen();
            // 回写弹出前的poptype
            pop_type.value = moreThan7sPropsBeforePopType.value as any;
            showAddToScreenNew.value = false;
            setVideoPlay();
        };

        const handleAddToScreenOld = () => {
            sendLog({
                type: 'click',
                name: 'PWA_POP',
                value: {
                    author_id: author_id.value,
                    photo_id: photo_id.value,
                    pop_type: pop_type.value,
                    button_type: 'main',
                    skip_to: 'icon',
                },
            });
            handleAddToScreen();
            showAddToScreenOld.value = false;
            // EventBus.$emit('setVideoPlay');
            setVideoPlay();
        };

        const handleAddToScreen = () => {
            try {
                const { pwa_source, _p } = query;

                radarLog({
                    name: 'PWA_INSTALL_PROMPT',
                    event_type: 'show',
                    category: 'KWAI_SHARE',
                    message: `PWA_INSTALL_PROMPT`,
                    src: window.location.pathname,
                });
                window.deferredPrompt.prompt();
                // @ts-ignore
                window.deferredPrompt.userChoice.then((choiceResult: any) => {
                    if (choiceResult.outcome === 'accepted') {
                        localStorage.setItem('cacheShareHref', window.location.href);
                        localStorage.setItem('cachePwaSource', pwa_source || _p);
                        //   安装成功 埋点
                        immediateSendLog({
                            type: 'click',
                            name: 'INSTALL_PWA',
                            value: {
                                is_pwa: 1,
                                author_id: author_id.value,
                                photo_id: photo_id.value,
                            },
                        });
                        radarLog({
                            name: 'PWA_INSTALL_SUCESS',
                            event_type: 'show',
                            category: 'KWAI_SHARE',
                            message: `PWA_INSTALL_SUCESS`,
                            src: window.location.pathname,
                        });
                    } else {
                        // 安装失败埋点
                        immediateSendLog({
                            type: 'click',
                            name: 'INSTALL_PWA',
                            value: {
                                is_pwa: 0,
                                author_id: author_id.value,
                                photo_id: photo_id.value,
                            },
                        });
                        radarLog({
                            name: 'PWA_INSTALL_FAIL',
                            event_type: 'show',
                            category: 'KWAI_SHARE',
                            message: `PWA_INSTALL_FAIL`,
                            src: window.location.pathname,
                        });
                    }
                    // @ts-ignore
                    window.deferredPrompt = null;
                });
            } catch (error) {
                radarLog({
                    name: 'PWA_INSTALL_PROMPTERR',
                    event_type: 'show',
                    category: 'KWAI_SHARE',
                    message: `PWA_INSTALL_PROMPTERR`,
                    src: window.location.pathname,
                });
            }
        };
        const handleAddToScreenOldClose = (params: Record<string, string>) => {
            onClickVideo();
            sendPopShowLog({ logType: 'click', ...params });
            showAddToScreenOld.value = false;
        };

        const handleInfoClick = async ({ type }: { type: keyof typeof VideoGuidanceSource }) => {
            const { pwa_source } = query;
            sendLog({
                type: 'click',
                name: 'PLAY_PHOTO',
                value: {
                    author_id: author_id.value,
                    photo_id: photo_id.value,
                    button_type: type,
                },
            });
            if (type === 'follow') {
                radarLog({
                    name: 'PWA_FOLLOW',
                    event_type: 'show',
                    category: 'KWAI_SHARE',
                    message: `PWA_FOLLOW`,
                    src: window.location.pathname,
                });
                // clickFollowAction()
                debounceClickFollowAction();
                // 分享过来的还是要拉登录弹窗
            } else if ((type === 'name' || type === 'photo') && pwa_source !== 'share') {
                state.videoElement?.pause();
                // proxy.$router.push({ path: `/user/${author_id.value}`, query: { ...query, page_source: 'foryou' } });
                proxy.$router.push({ path: `/@${kwaiId.value}`, query: { ...query, page_source: 'foryou' } });
            } else {
                // showWakeNotice.value = true
                if (showLoginPopup.value) return;
                showNewOpenKwaiNotice.value = true;
                onClickVideo();
                pop_type.value = PopType.video_interaction_guidance;
                video_guidance_source.value = VideoGuidanceSource[type];
            }
        };

        const handleActionClick = async ({ type }: { type: string }) => {
            sendLog({
                type: 'click',
                name: 'PLAY_PHOTO',
                value: {
                    author_id: author_id.value,
                    photo_id: photo_id.value,
                    button_type: type,
                    is_telegram: istma,
                },
            });
            // todo 需要抽离
            if (type === 'favorite') {
                radarLog({
                    name: 'PWA_FAVORITE',
                    event_type: 'show',
                    category: 'KWAI_SHARE',
                    message: `PWA_FAVORITE`,
                    src: window.location.pathname,
                });
                debounceClickLikeAction();
                // clickLickAction()
            } else if (type === 'comment') {
                commentDialogVisable.value = true;
                fetchSeoComment(photo_id.value);
            } else if (type === 'reward') {
                showPayViaWalletNotice.value = true;
                console.log(`showPayViaWalletNotice${{ istma }}`);
            } else {
                if (showLoginPopup.value) return;
                showNewOpenKwaiNotice.value = true;
                onClickVideo();
                pop_type.value = PopType.video_interaction_guidance;
                video_guidance_source.value = type;
            }
        };

        const headerFollowClick = () => {
            sendLog({
                type: 'click',
                name: 'FUNCTION_MODE',
                value: {
                    author_id: author_id.value,
                    photo_id: photo_id.value,
                    button_type: 'follow',
                },
            });
            pop_type.value = PopType.function_interaction_guidance;
            // showWakeNotice.value = true
            showNewOpenKwaiNotice.value = true;
            onClickVideo();
        };

        const handleNewOpenKwaiNoticeClose = (params: Record<string, string>) => {
            showNewOpenKwaiNotice.value = false;
            sendPopShowLog({ logType: 'click', ...params });
            if (!props.isIos && window.deferredPrompt) {
                showAddToScreenOld.value = true;
                pop_type.value = PopType.install_guidance;
            } else {
                setVideoPlay();
            }
        };

        const handleNewOpenKwaiNotice = (params: Record<string, string>) => {
            sendPopShowLog({ logType: 'click', ...params });
            proxy.$bus.emit('launchApp', { callAppPath: `work/${photo_id.value}` });
            setTimeout(() => {
                showNewOpenKwaiNotice.value = false;
            }, 0);
            setVideoPlay();
        };
        const handleOpenKwaiNoticeClose = (params: Record<string, string>) => {
            showWakeNotice.value = false;
            sendPopShowLog({ logType: 'click', ...params });
            if (!props.isIos && window.deferredPrompt) {
                showAddToScreenOld.value = true;
                pop_type.value = PopType.install_guidance;
            } else {
                setVideoPlay();
            }
        };

        const handleLoginPopupClose = () => {
            showLoginPopup.value = false;
        };

        const handleLoginPopupOpenkwai = () => {
            showLoginPopup.value = false;
            proxy.$bus.emit('launchApp', { callAppPath: 'home' });
            setTimeout(() => {
                showNewOpenKwaiNotice.value = false;
            }, 0);
            setVideoPlay();
        };

        const handleLoadingChange = (value: boolean) => {
            proxy.$bus.emit('isLoad', value);
        };

        // Tele 钱包
        const handleDisconnectWallet = async () => {
            if (tonConnector.connected) {
                Toast({
                    message: `tonConnector.account + ${tonConnector.account}`,
                });
                tonConnector.disconnect();
                Toast({
                    message: 'disconnect successfully',
                });
            } else {
                Toast({
                    message: 'wallet not connected',
                });
            }
        };

        const handleConnectWallet = async () => {
            if (tonConnector.connected) {
                Toast({
                    message: 'Wallet connected',
                });
                return;
            }
            const connectedWallet = await tonConnector.openModal().catch((err: any) => {
                console.log('tg miniApp: connectWallet error %@', err);
            });
        };

        const handlePraiseViaWallet = async (params: Record<string, string>) => {
            sendTelegramPraisePopLog({ logType: 'click', ...params });
            const { pay_amount } = params;
            setTimeout(() => {
                showPayViaWalletNotice.value = false;
            }, 0);

            // createTgWalletOrder(pay_amount);
            // ton connect wallet
            if (!tonConnector.connected) {
                tonConnector.connectWallet();
            }
            const defautTonAmount = (0.1368 * parseFloat(pay_amount) * 1000000000).toFixed(0);
            const tonAmount = await tonapiExchangeUSDToTon(pay_amount);
            const transaction = {
                validUntil: Date.now() + 5 * 60 * 1000,
                messages: [
                    {
                        address: 'UQCN2heFqhDuPM_LPRRS0_k6WwtBWiB4tWevYZO5iYh1fDVc',
                        amount: tonAmount || defautTonAmount,
                    },
                ],
            };
            const result = await tonConnector
                .sendTransaction(transaction, {
                    modals: ['before', 'success', 'error'],
                    notifications: ['before', 'success', 'error'],
                })
                .catch((err: any) => {
                    console.log('tg miniApp: sendTransaction error', err);
                });
        };

        const handlePraisePendantConfirm = async (params: Record<string, string>) => {
            sendTelegramWidgetLog({ logType: 'click', ...params });
            const { openGroup } = useTelegram();
            openGroup();
            console.log('tg miniApp: ', 'open grounp');
        };

        const handlePraiseViaWalletClose = (params: Record<string, string>) => {
            showPayViaWalletNotice.value = false;
            console.log('tg miniApp: ', 'close praise panel');
        };

        // ios 视频资源url
        const iosVideoUrl = computed(() => {
            return formatUrls(activePhotoItem.value?.main_mv_urls[0].url);
        });

        const iosVideoObjectFit = computed(() => {
            return getObjectFit(activePhotoItem.value?.ext_params);
        });

        const handleVideoPlaying = () => {
            // 记录一下当前视频正常开始播放的时间
            activeVideoPlayingTime.value = new Date().getTime();
            handleLoadingChange(false);
        };

        // 页面隐藏上报视频时间
        const handleVisibilityChange = () => {
            console.log('handleVisibilityChange', document.hidden, document.visibilityState);
            // 点击暂停后不触发visibie事件
            if (showPlayBtn.value) {
                if (document.hidden) {
                    sendVideoTimeLog();
                }
                return;
            }
            if (!state.videoElement) {
                state.videoElement = getVideoEle();
            }
            // 切换出去时发送最后一个视频的时间 切换回来重新计时
            if (
                document.visibilityState === 'visible' &&
                !showLoginPopup.value &&
                !showNewOpenKwaiNotice.value &&
                !showAddToScreenNew.value &&
                !showAddToScreenOld.value
            ) {
                setVideoPlay();
                activeVideoPlayingTime.value = new Date().getTime();
            } else {
                state.videoElement?.pause();
                sendVideoTimeLog();
            }
        };

        const changeLoginStatus = (val: boolean) => {
            proxy.$store.commit('setIsLogin', val);
        };

        onActivated(() => {
            document.addEventListener('visibilitychange', handleVisibilityChange);
            if (!isFirstDone) {
                isFirstDone = true;
            } else {
                setVideoPlay();
            }
        });

        onMounted(async () => {
            // 初始化判断是否登录
            isLogin().then(res => {
                proxy.$store.commit('setIsLogin', res);
            });
            // const isFromPwaEntry = isPwa()
            let isFetching: boolean = false; // 记录当前是否已经校验login接口

            // 小程序初始化
            initTg(() => {
                tgWebAppStartup();
                tgPraiseAmountList();
            });
            const istmaT = isTMA();
            istma.value = istmaT;
            // showTelegramWidget.value = istmaT;
            watch(
                () => watchOneVideoTime.value,
                async newValue => {
                    // if (newValue === 7 && !watchTimerDialogIsShowed.value && !props.isIos && !isFromPwaEntry && window.deferredPrompt) {
                    //   watchTimerDialogIsShowed.value = true;
                    //   showAddToScreenNew.value = true
                    //   // 可能会出现弹窗重叠 记录一下上一个poptype
                    //   moreThan7sPropsBeforePopType.value = pop_type.value
                    //   pop_type.value = PopType.more_than_7s
                    //   onClickVideo()
                    //   showPlayBtn.value = false;
                    // }
                    const { isLogin } = proxy.$store.state || {};

                    if (
                        newValue >= Number(startupData.forceLoginTime) &&
                        slideIndex.value >= Number(startupData.forceLoginVV) &&
                        !showLoginPopup.value &&
                        !showNewOpenKwaiNotice.value &&
                        !isLogin
                    ) {
                        if (isFetching) return;
                        isFetching = true;
                        if (await isLogin()) {
                            isFetching = false;
                            proxy.$store.commit('setIsLogin', true);
                            watchOneVideoTime.value = 0;
                            return;
                        }
                        isFetching = false;
                        isAllowLoginPopupClose.value = false;
                        showLoginPopup.value = true;
                        onClickVideo();
                        showPlayBtn.value = false;
                        watchOneVideoTime.value = 0;
                    }
                }
            );

            watch(
                () => props.videoList,
                (newValue, oldValue) => {
                    if (newValue && oldValue.length !== 0) {
                        nextTick(() => {
                            // 重制观看单个视频时间
                            watchOneVideoTime.value = 0;
                            setVideoPlay();
                        });
                    }
                    formatVideoList.value = newValue;
                }
            );

            // todo 要不要改弹窗频率限制
            showNewOpenKwaiNotice.value = true;
            document.addEventListener('visibilitychange', handleVisibilityChange);

            proxy.$bus.on('footerNav', () => {
                showNewOpenKwaiNotice.value = true;
                onClickVideo();
            });
            tonConnector = await tonConnectUI();
        });

        onUnmounted(() => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        });

        onDeactivated(() => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        });

        return {
            ...toRefs(state),
            swiperOption,
            getObjectFit,
            formatUrls,
            onClickVideo,
            showPlayBtn,
            showPoster,
            iosVideoUrl,
            iosVideoObjectFit,
            slideIndex,
            showAddToScreenNew,
            handleAddToScreenNew,
            handleAddToScreenOld,
            handleAddToScreenOldClose,
            showAddToScreenOld,
            handleActionClick,
            showNewOpenKwaiNotice,
            handleNewOpenKwaiNoticeClose,
            handleNewOpenKwaiNotice,
            handlePraiseViaWallet,
            handlePraiseViaWalletClose,
            handleDisconnectWallet,
            handleConnectWallet,
            showPayViaWalletNotice,
            showTelegramWidget,
            handlePraisePendantConfirm,
            handleInfoClick,
            showWakeNotice,
            handleOpenKwaiNoticeClose,
            headerFollowClick,
            loading,
            handleLoadingChange,
            activePhotoItem,
            author_id,
            photo_id,
            handleVideoPlaying,
            showLoginPopup,
            handleLoginPopupClose,
            handleLoginPopupOpenkwai,
            isAllowLoginPopupClose,
            checkDbClick,
            formatVideoList,
            clickFollowAction,
            changeLoginStatus,
            swiperRef,
            commentLists,
            commentDialogVisable,
            showCommentLoading,
            fetchSeoComment,
            videoRefs,
            onError,
            commentRef,
            iosVideoCompRef,
            istma,
            tonConnector,
        };
    },
});
